export default function($) {
  $('.js-search-trigger').on('click', function() {
    $('.js-search-overlay').css( 'display', 'flex' );
    $('.js-search-overlay').find('input').focus();
    $(this).attr('aria-expanded', 'true')
  })

  $('.js-search-close').on('click', function() {
    $('.js-search-overlay').hide();
    $('.js-search-trigger').attr('aria-expanded', 'false')
  })
}
